import template from './add-substitution-realization.html';

class AddSubstitutionRealizationComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state, $stateParams, moment,
    RealizationService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.moment = moment;
    this.RealizationService = RealizationService;

    this.realization = {};
    this.date = new Date();
  }

  $onChanges(changes) {
    if (changes.substitution) {
      this.substitution = {...this.substitution};
    }
  }

  $onInit() {
    this.startTime = this.substitution.startTime;
    this.endTime = this.substitution.endTime;
    this.date = this.moment(this.substitution.date);
  }

  add(form) {
    if (form.$invalid) {
      return false;
    }

    this.realization.date = this.date.format('YYYY-MM-DD');
    this.realization.startTime = this.startTime;
    this.realization.endTime = this.endTime;
    this.realization.substituteActivityId = this.$stateParams.activityId;
    this.RealizationService.add(
      {
        data: this.realization,
        addToLocal: true
      }
    ).then(() => {
      this.$state.go('modules.realizations.byEmployee');
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Dodano realizację')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const AddSubstitutionRealization = {
  bindings: {
    substitution: '<'
  },
  template,
  controller: AddSubstitutionRealizationComponent
};
